import { combineReducers } from 'redux';
import RecipeListReducer from './acct_recipes_reducer';
import ShopListListReducer from './shop_list_list_reducer';
import ShopListReducer from './shop_list_reducer';
import ItemListReducer from './item_list_reducer';
import RefDataReducer from './ref_data_reducer';

const rootReducer = combineReducers({
  recipes: RecipeListReducer,
  shop_lists: ShopListListReducer,
  current_shop_list: ShopListReducer,
  items: ItemListReducer,
  ref_data: RefDataReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js